import React from 'react';
import FlexBox from './Container/FlexBox';
import styled from 'styled-components';
const Label = styled.span `
  color: ${({ theme }) => theme.palette.grey['A500']};
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16.8px;
  text-transform: uppercase;
`;
const Value = styled.span `
  color: ${({ theme }) => theme.palette.grey['A800']};
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
const PropertyField = ({ label, value }) => {
    return (React.createElement(FlexBox, { flexDirection: "column", alignItems: "flex-start", gap: 0.5 },
        React.createElement(Label, null, label),
        React.createElement(Value, null, value)));
};
export default PropertyField;
